import { create } from "zustand"
import type { TAddSimpleCategoryModalStore } from "types/configuration.type"

// Add category stores
export const useAddSimpleCategoryStore = create<TAddSimpleCategoryModalStore>((set) => ({
	category: {
		name: "",
		label: "",
		topLevelCategory: "",
		superCategory: "",
		modelNumbers: [],
	},

	setFormValues: ({ name, label, topLevelCategory, superCategory }) =>
		set((state) => ({
			category: { ...state.category, name, label, topLevelCategory, superCategory },
		})),

	setModelNumbers: (modelNumbers: number[]) =>
		set((state) => ({
			category: { ...state.category, modelNumbers },
		})),

	resetForm: () =>
		set(() => ({
			category: {
				name: "",
				label: "",
				topLevelCategory: "",
				superCategory: "",
				modelNumbers: [],
			},
		})),
}))
